import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import Heading from '../../../generic-components/Heading';
import { ReactComponent as CloseIcon } from '../../../assets/icons/svg/shared/ic-shared-close.svg';
import { ReactComponent as RightArrowIcon } from '../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import { IntroContentMap } from '../consts';
import { ACTION_MODAL_TYPES, ActionModal } from '../../../DesignSystem/ActionModal';

interface INavigationHeader {
  onBack: () => void;
  onClose: () => void;
  hideBackButton?: boolean;
  shouldDirectClose?: boolean;
  disableMarginBottom?: boolean;
}

export const NavigationHeader = ({ onBack, onClose, hideBackButton, shouldDirectClose, disableMarginBottom }: INavigationHeader) => {
  const { t } = useTranslation();
  const { moveType } = useParams();
  const [isCancelFlowModalOpen, setIsCancelFlowModalOpen] = useState<boolean>(false);
  const handleClose = () => {
    if (shouldDirectClose) onClose();
    else setIsCancelFlowModalOpen(true);
  };
  return (
    <div className={`relative w-full flex items-center justify-between px-[34px] py-[2px] ${disableMarginBottom ? '' : 'mb-[64px]'}  border-b bg-bw00 border-bw03`}>
      {!hideBackButton && (
        <LiliButton
          onClick={onBack}
          className='w-fit'
          id='back'
          title='Back'
          icon={<RightArrowIcon className='rotate-180 stroke-bw08 text-bw08' />}
          type={LiliButtonType.SKIP}
        />
      )}
      {hideBackButton && <span className='w-[180px]' />}
      <Heading
        title={t(IntroContentMap[moveType as keyof typeof IntroContentMap].main_header, { defaultValue: IntroContentMap[moveType as keyof typeof IntroContentMap].main_header })}
        className='font-metricR text-bw08 text-[20px] absolute left-1/2 transform -translate-x-1/2'
      />
      <LiliButton
        onClick={handleClose}
        className='w-fit'
        id='closeUpdate'
        title=''
        type={LiliButtonType.SKIP}
        icon={<CloseIcon className='text-bw08' />}
      />
      {isCancelFlowModalOpen && (
        <ActionModal
          description={t('MOVE_MONEY.LEAVE_FLOW_MODAL.DESCRIPTION')}
          modalType={ACTION_MODAL_TYPES.DESTRUCTIVE}
          title={t('MOVE_MONEY.LEAVE_FLOW_MODAL.TITLE')}
          mainButtonTitle={t('MOVE_MONEY.LEAVE_FLOW_MODAL.MAIN_CTA')}
          cancelButtonTitle={t('MOVE_MONEY.LEAVE_FLOW_MODAL.SECONDARY_CTA')}
          onSubmit={onClose}
          onCancel={() => setIsCancelFlowModalOpen(false)}
        />
      )}
    </div>
  );
};
